<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#FFF">
        <g>
          <g>
            <g>
              <path
                d="M7.5 1c.245 0 .45.177.492.41L8 1.5V8h6.5c.276 0 .5.224.5.5 0 .245-.177.45-.41.492L14.5 9H8v6.5c0 .276-.224.5-.5.5-.245 0-.45-.177-.492-.41L7 15.5V9H.5C.224 9 0 8.776 0 8.5c0-.245.177-.45.41-.492L.5 8H7V1.5c0-.276.224-.5.5-.5z"
                transform="translate(-1262 -36) translate(240) translate(1010 26) translate(12 10)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'PlusIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
  },
};
</script>

<style lang="scss"></style>
